import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    Grid,
    Stack,
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    Divider
} from '@mui/material';
import DiscountIcon from '@mui/icons-material/Discount';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VerifiedIcon from '@mui/icons-material/Verified';
import BoltIcon from '@mui/icons-material/Bolt';
import GroupIcon from '@mui/icons-material/Group';

import EditCoupon from './EditCoupon';
import { AddCircle, EditSquare } from '@mui/icons-material';
import CreateCouponForm from './CreateCouponForm';
import AuthService from '../Auth/AuthService';

const CouponList = ({ coupons }) => {
    // const [coupons, setCoupons] = useState([])
    const [mockCoupons, setMockCoupons] = useState([]);
    const [coupon, setCoupon] = useState(mockCoupons);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [open, setOpen] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        // setMockCoupons(coupons);
        if (hasFetched.current) return;
        hasFetched.current = true;
        loadData();
    }, []);

    const loadData = async () => {
        const url = AuthService.pathUrl('GET', '/coupons')
        const response = await AuthService.getAuth(url);
        setMockCoupons(response);
    }

    const handleSave = async (updatedCoupon) => {
        // const updated = coupon.map(c => c.id === updatedCoupon.id ? updatedCoupon : c);
        setSelectedCoupon(null);
        const url = AuthService.pathUrl("PUT", '/coupons/' + updatedCoupon.id);
        const response = await AuthService.putAuth(url, updatedCoupon);
        setCoupon(updatedCoupon);
        console.log('Submitted Coupon:', updatedCoupon);
    };

    const handleDelete = async (couponId) => {
        console.log("Delete clicked:", couponId);
        const url = AuthService.pathUrl("DELETE", '/coupons/' + couponId);
        const response = await AuthService.deleteAuth(url);
        window.location.reload();
        alert(response.status);
    };

    return (
        <Box sx={{ mt: 2, px: 2 }}>
            <Card elevation={6} sx={{ borderRadius: 4, p: 3 }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" >
                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            <DiscountIcon sx={{ mr: 1, verticalAlign: 'middle', color: '#1b1914' }} />
                            Available Coupons
                        </Typography>
                        <Typography variant="h5" gutterBottom fontWeight="bold" onClick={() => setOpen(true)}>
                            <AddCircle sx={{ mr: 1, verticalAlign: 'middle', color: '#1b1914', cursor: 'pointer' }} />
                        </Typography>
                    </Box>
                    <Divider sx={{ mb: 5 }} />
                    <Grid container spacing={3}>
                        {mockCoupons?.map((coupon) => (
                            <Grid item xs={12} sm={6} md={4} key={coupon.id}>
                                <Card elevation={4} sx={{ borderRadius: 3 }}>
                                    <CardContent>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                                            <Typography variant="h6">
                                                <DiscountIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                                                {coupon.code}
                                            </Typography>
                                            <Stack direction="row" spacing={1}>
                                                <Tooltip title="Edit">
                                                    <IconButton color="primary" onClick={() => setSelectedCoupon(coupon)}>
                                                        <EditSquare color='warning' />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete">
                                                    <IconButton color="error" onClick={() => handleDelete(coupon.id)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Stack>

                                        <Typography variant="body2" color="text.secondary" mb={1}>
                                            {coupon.discountType === "FLAT"
                                                ? `Flat ₹${coupon.discountAmount} off`
                                                : `Discount: ${coupon.discountPercentage}%`}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary" mb={1}>
                                            <CalendarTodayIcon sx={{ fontSize: 16, mr: 1 }} />
                                            {coupon.startDate} → {coupon.endDate}
                                        </Typography>

                                        <Box mb={1}>
                                            <Typography variant="caption" color="text.secondary">
                                                Plans:
                                            </Typography>
                                            <Stack direction="row" spacing={0.5} flexWrap="wrap">
                                                {coupon?.planName?.map((plan, index) => (
                                                    <Chip key={index} size="small" label={plan} color="warning" />
                                                ))}
                                            </Stack>
                                        </Box>

                                        <Stack direction="row" spacing={1}>
                                            {coupon.isActive && (
                                                <Chip icon={<VerifiedIcon />} label="Active" color="success" size="small" />
                                            )}
                                            {coupon.oneTimePerUser && (
                                                <Chip icon={<GroupIcon />} label="One-Time" color="warning" size="small" />
                                            )}
                                            {coupon.autoApply && (
                                                <Chip icon={<BoltIcon />} label="Auto Apply" color="secondary" size="small" />
                                            )}
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>
            <Dialog open={Boolean(selectedCoupon)} onClose={() => setSelectedCoupon(null)} maxWidth="md" fullWidth>
                <DialogContent sx={{ p: 0 }}>
                    {selectedCoupon && <EditCoupon initialData={selectedCoupon} onSave={handleSave} />}
                </DialogContent>
            </Dialog>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth >
                <DialogContent sx={{ p: 0 }}>
                    {open && <CreateCouponForm onSave={handleSave} onSuccess={() => { setOpen(false); loadData(); }} />}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default CouponList;
